import { fetchGet } from './api';
import { IDiscipline } from '../types/discipline.type';

export const fetchDisciplines = () => fetchGet<IDiscipline[]>('disciplines');
